export interface ServerData<T> {
  success: boolean;
  data: T;
}

interface ErrorMsg {
  name: string;
  messages: string[];
}

export interface ServerError {
  success: boolean;
  data: object;
  status: string;
  code: number;
  errors: ErrorMsg[];
}

export enum MODALS {
  RESET_PASSWORD = 'ResetPassword',
  AUTHORIZATION = 'Authorization',
  PHOTO_UPLOAD = 'PhotoUpload',
  EMAIL_SENT = 'EmailSent',
  BASE_PAYMENT_MODAL = 'BasePaymentModal',
  SUBSCRIPTIONS_MODAL = 'SubscriptionsModal',
  SUCCESS_PAYMENT = 'SuccessPayment',
  DECLINED_PAYMENT = 'DeclinedPayment',
  CANCEL_SUBSCRIPTION_MODAL = 'CancelSubscriptionModal',
  RENEW_SUBSCRIPTION_MODAL = 'RenewSubscriptionModal',
  REMINDERS = 'Reminders',
}
